import { ReactNode } from 'react';
import { CodeType } from '../CodeType';
import { BuildCodeParams, CodeSample } from './CodeSample';
import Paragraph from 'antd/lib/typography/Paragraph';

/* eslint-disable no-useless-escape */
export default class MobileIosSample extends CodeSample {
  name = 'React Native';
  language = 'javascript';
  codeType = CodeType.MOBILE;
  tabIcon = '';
  commentChar = undefined;

  buildCode({ environment, notification, user }: BuildCodeParams): ReactNode {
    return (
      <>
        <Paragraph style={{ paddingTop: 10 }}>
          Our React Native SDK is currently in beta. Please get in touch with us
          to get access.
        </Paragraph>
      </>
    );
  }
}
/* eslint-enable no-useless-escape */
